<div class="col">
  <div class="row">
    <div class="col card-section ml-3 mr-3 p-5">
      <div class="blue-circle circle">
        <div class="circle-icon__box">
          <i class="fas fa-share-alt text-white"></i>
        </div>
      </div>
      <div class="text-center">
        <h3 class="font-weight-bold mb-3">321</h3>
        <h5>App Shares</h5>
      </div>
    </div>
    <div class="col card-section mr-3 p-5">
      <div class="red-circle circle">
        <div class="circle-icon__box">
          <i class="fas fa-globe-europe text-white"></i>
        </div>
      </div>
      <div class="text-center">
        <h3 class="font-weight-bold mb-3">{{numberOfVisitors.visitorsCount}}</h3>
        <h5>Visits</h5>
      </div>
    </div>
    <div class="col card-section mr-3 p-5">
      <div class="green-circle circle">
        <div class="circle-icon__box-last">
          <i class="fas fa-mobile text-white"></i>
        </div>
      </div>
      <div class="text-center">
        <h3 class="font-weight-bold mb-3">
          <span class="active-users p-2">
            {{ activeMobileUsers.activeMobileUsersCount.toFixed() | number }}
          </span>
          <span class="p-2">
            {{ activeMobileUsers.allMobileUsersCount.toFixed() | number }}
          </span>
        </h3>
        <h5>Mobile App Active Users</h5>
      </div>
    </div>
  </div>
